// 元付業者
const Ea = {
  namespaced: true,

  state: {
    // 元付け業者一覧/編集モーダル
    modal: false,
    // 元付業者 プルダウンリスト
    list: [],
    // 担当者 プルダウンリスト
    chargePersonList: [],
    // 元付業者 検索項目
    search: {
      name: '',
      page: 1,
      perPage: 20,
    },
    // 登録/更新情報
    formItem: {
      active_portalsites: [], // 掲載可サイト
      name_eacompany: '', // 業者名
      kana_eacompany: '', // 業者名(カナ)
      shopname_eacompany: '', // 屋号
      zip1: '', // 郵便番号1
      zip2: '', // 郵便番号2
      pref_cd: null, // 都道府県CD
      shiku_cd: null, // 市区CD
      choson_cd: null, // 町村CD
      aza_cd: null, // チョウ目CD
      address_else: '', // その他住所
      um_eachargeperson: [
        {
          um_eachargeperson_id: null,
          um_eachargeperson_name: '',
          um_eachargeperson_tel: '',
          um_eachargeperson_mail: '',
        },
        {
          um_eachargeperson_id: null,
          um_eachargeperson_name: '',
          um_eachargeperson_tel: '',
          um_eachargeperson_mail: '',
        },
        {
          um_eachargeperson_id: null,
          um_eachargeperson_name: '',
          um_eachargeperson_tel: '',
          um_eachargeperson_mail: '',
        },
        {
          um_eachargeperson_id: null,
          um_eachargeperson_name: '',
          um_eachargeperson_tel: '',
          um_eachargeperson_mail: '',
        },
        {
          um_eachargeperson_id: null,
          um_eachargeperson_name: '',
          um_eachargeperson_tel: '',
          um_eachargeperson_mail: '',
        },
        {
          um_eachargeperson_id: null,
          um_eachargeperson_name: '',
          um_eachargeperson_tel: '',
          um_eachargeperson_mail: '',
        },
      ],
      tel_eacompany: '', // TEL
      fax_eacompany: '', // FAX
      note_eacompany: '', // 備考
      ea_account_group: '', // 取引先グループ
      ea_web_site: '', // WEBサイト
      ea_holiday: '', // 休日
      sel_futures_confirmation: null, // 先物物件確認方法
    },
    // 登録/更新時に必要なパーツ
    formParts: {
      prefList: [],
      shikuList: [],
      chosonList: [],
      azaList: [],
    },
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getList: state => {
      return state.list
    },
    getSearch: state => {
      return state.search
    },
    getChargePersonList: state => {
      return state.chargePersonList
    },
    getFormItem: state => {
      return state.formItem
    },
    getFormParts: state => {
      return state.formParts
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setList(state, list) {
      state.list = list
    },
    setSearch(state, search) {
      state.search = search
    },
    setChargePersonList(state, chargePersonList) {
      state.chargePersonList = chargePersonList
    },
    setFormItem(state, formItem) {
      state.formItem = formItem
    },
    setFormParts(state, formParts) {
      state.formParts = formParts
    },
  },
  actions: {
    resetSearch({ commit }) {
      const search = {
        name: '',
        tel: '',
        page: 1,
        perPage: 20,
      }
      commit('setSearch', search)
    },
    resetFormItem({ commit }) {
      const formItem = {
        active_portalsites: [], // 掲載可サイト
        name_eacompany: '', // 業者名
        kana_eacompany: '', // 業者名(カナ)
        shopname_eacompany: '', // 屋号
        zip1: '', // 郵便番号1
        zip2: '', // 郵便番号2
        pref_cd: null, // 都道府県CD
        shiku_cd: null, // 市区CD
        choson_cd: null, // 町村CD
        aza_cd: null, // チョウ目CD
        address_else: '', // その他住所
        um_eachargeperson: [
          {
            um_eachargeperson_id: null,
            um_eachargeperson_name: '',
            um_eachargeperson_tel: '',
            um_eachargeperson_mail: '',
          },
          {
            um_eachargeperson_id: null,
            um_eachargeperson_name: '',
            um_eachargeperson_tel: '',
            um_eachargeperson_mail: '',
          },
          {
            um_eachargeperson_id: null,
            um_eachargeperson_name: '',
            um_eachargeperson_tel: '',
            um_eachargeperson_mail: '',
          },
          {
            um_eachargeperson_id: null,
            um_eachargeperson_name: '',
            um_eachargeperson_tel: '',
            um_eachargeperson_mail: '',
          },
          {
            um_eachargeperson_id: null,
            um_eachargeperson_name: '',
            um_eachargeperson_tel: '',
            um_eachargeperson_mail: '',
          },
          {
            um_eachargeperson_id: null,
            um_eachargeperson_name: '',
            um_eachargeperson_tel: '',
            um_eachargeperson_mail: '',
          },
        ],
        tel_eacompany: '', // TEL
        fax_eacompany: '', // FAX
        note_eacompany: '', // 備考
        ea_account_group: '', // 取引先グループ
        ea_web_site: '', // WEBサイト
        ea_holiday: '', // 休日
        sel_futures_confirmation: null, // 先物物件確認方法
      }
      commit('setFormItem', formItem)
    },
    resetFormParts({ commit }) {
      const formParts = {
        prefList: [],
        shikuList: [],
        chosonList: [],
        azaList: [],
      }
      commit('setFormParts', formParts)
    },
  },
}

export default Ea
